import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const HomeServiceCard = ({ service, index }) => {
  const delay = index * 0.1;
  const dataStreamRef = useRef(null);
  
  // Move useEffect before conditional return
  useEffect(() => {
    // Only run this effect if we have a valid service and it's AI or IT related
    if (dataStreamRef.current && service && (service.iconClass === 'service-icon-ai' || service.iconClass === 'service-icon-it')) {
      const dataStreamElement = dataStreamRef.current;
      
      // Clear existing data bits
      dataStreamElement.innerHTML = '';
      
      // Create random binary/hexadecimal data stream
      for (let i = 0; i < 20; i++) {
        const dataBit = document.createElement('div');
        dataBit.className = 'data-bit';
        
        // Alternating between binary and hex for visual diversity
        dataBit.innerText = Math.random() > 0.5 
          ? Math.floor(Math.random() * 2) // Binary (0 or 1)
          : Math.floor(Math.random() * 16).toString(16); // Hex (0-F)
        
        dataBit.style.left = `${Math.random() * 100}%`;
        dataBit.style.animationDelay = `${Math.random() * 8}s`;
        dataBit.style.animationDuration = `${5 + Math.random() * 8}s`;
        
        dataStreamElement.appendChild(dataBit);
      }
    }
  }, [service]); // Add service as dependency
  
  // FIXED: Moved conditional return after hook declarations
  if (!service || !service.title) {
    console.warn('HomeServiceCard: Missing required service data');
    return null; // Return null to avoid rendering a broken card
  }

  return (
    <motion.div
      className="service-card-wrapper"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
    >
      <div className="home-service-card">
        {/* AI-themed icon container with animation effects */}
        <div className={`service-icon-container ${service.iconClass || ''}`}>
          <span className="service-icon" style={{ '--delay': `${delay}s` }}>
            {service.icon}
          </span>
          
          {/* Add robot eyes for AI service */}
          {service.iconClass === 'service-icon-ai' && (
            <div className="robot-eyes">
              <div className="robot-eye"></div>
              <div className="robot-eye"></div>
            </div>
          )}
          
          {/* Circuit paths and nodes for tech effect */}
          <div className="circuit-paths">
            <div className="circuit-path"></div>
            <div className="circuit-path"></div>
            <div className="circuit-path"></div>
            <div className="circuit-node"></div>
            <div className="circuit-node"></div>
            <div className="circuit-node"></div>
          </div>
        </div>
        
        <h3>{service.title}</h3>
        <p>{service.description || 'Service description'}</p>
        
        <div className="service-features">
          {service.features && service.features.slice(0, 3).map((feature, i) => (
            <span key={i} className="feature-tag">{feature}</span>
          ))}
        </div>
        
        {/* Digital data stream effect for AI/tech services */}
        <div className="data-stream" ref={dataStreamRef}></div>
      </div>
    </motion.div>
  );
};

export default HomeServiceCard;
